import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyBeforePrivacy20250729'

const PagePolicyBeforePrivacy20250729 = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforePrivacy20250729
